import { useState } from "react";
import { useSelector } from "react-redux";
import { getAllOrders } from "../../services/rashTradeServices";
import { dashboardAccountDetails } from "../../staticData/transactions";
import { exportToExcel } from "../../utils/common-functions";

const BalanceDetails = ({ balanceDetails, isDarkMode, getUserBinanceAccountInfoAction }) => {
    const [showToolTip, setShowToolTip] = useState(false);
    const exportOrdersToExcel = async () => {
        const data = await getAllOrders();
        exportToExcel({ apiData: data, fileName: "RashTrade-allOrders" });
    };
    return (
        <div
            className={`flex-2 flex flex-col py-4 ${
                isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
            }  justify-center items-center  md:justify-start md:items-start  lg:flex-3 2xl:ml-0 2xl:mt-0 2xl:items-center w-full border-1 `}>
            <div className="flex flex-1 p-2 text-2xl cursor-pointer w-full justify-center ">
                <div
                    className="flex items-center"
                    onClick={() => getUserBinanceAccountInfoAction()}>
                    Balance Details
                </div>
                <div className=" flex items-center justify-center">
                    <img
                        onClick={exportOrdersToExcel}
                        className="w-6 h-6 ml-3  "
                        src="/icons/exportToExcel.png"
                        title="all orders"
                    />
                </div>
            </div>
            <div className="flex-12 px-3 flex flex-wrap w-full">
                {Object.entries(balanceDetails).map((detail) => {
                    return (
                        <div className=" flex w-full sm:w-1/2 justify-center mt-2">
                            <div
                                className={`w-8/12 ${
                                    isDarkMode ? "bg-primaryDark" : "bg-primaryLight"
                                } rounded-md px-2 py-1`}>
                                <div>{String(detail[1])}</div>
                                <div className="text-vsm">
                                    {dashboardAccountDetails[detail[0]].propLabel}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default BalanceDetails;
